import { Translate } from 'next-translate';

import {
  BidAcceptanceInviteNotification,
  SupplierDatabaseInviteNotification
} from '@components/layout/Header/Notifications/types';

export const mapCompanyInviteToNotification = (t: Translate, invite: SupplierDatabaseInviteNotification) => ({
  action_name: 'company_invitation',
  actions_object: {
    accepted_company_invite: {
      action: '',
      title: t('general.accept')
    },
    rejected_company_invite: {
      action: '',
      title: t('general.decline')
    },
  },
  activity_id: invite.id,
  additional_info: {},
  created_at: invite.created_at,
  is_read: false,
  is_seen: false,
  title: t('notifications.supplier_database_invitation'),
});

export const mapRequestInviteToNotification = (t: Translate, invite: BidAcceptanceInviteNotification) => ({
  action_name: 'request_invitation',
  actions_object: {
    accepted_request_invite: {
      action: '',
      title: t('general.accept')
    },
    rejected_request_invite: {
      action: '',
      title: t('general.decline')
    },
  },
  activity_id: invite.id,
  additional_info: {},
  created_at: invite.created_at,
  is_read: false,
  is_seen: false,
  title: t('notifications.request_invitation'),
});
